const SET_VALID_INCIDENT = 'SET_VALID_INCIDENT';
const CLEAR_VALID_INCIDENT = 'CLEAR_VALID_INCIDENT';
const SET_CONFLICTING_INCIDENTS = 'SET_CONFLICTING_INCIDENTS';
const CLEAR_CONFLICTING_INCIDENTS = 'CLEAR_CONFLICTING_INCIDENTS';
const SET_CONFLICTING_RELATIONSHIPS = 'SET_CONFLICTING_RELATIONSHIPS';
const CLEAR_CONFLICTING_RELATIONSHIPS = 'CLEAR_CONFLICTING_RELATIONSHIPS';

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  SET_VALID_INCIDENT,
  CLEAR_VALID_INCIDENT,
  SET_CONFLICTING_INCIDENTS,
  CLEAR_CONFLICTING_INCIDENTS,
  SET_CONFLICTING_RELATIONSHIPS,
  CLEAR_CONFLICTING_RELATIONSHIPS
};
